export enum AddOns {
  PREDICTIVE = 'predictive',
  PARTICIPANTS = 'participants',
  TRACKER_RENTAL = 'rent_tracker',
  TIMING = 'timing',
  SPONSOR = 'sponsor',
  API = 'dataFeed',
  KEYS = 'passcode_keys',
  HIGH_RESOLUTION = 'high_resolution',

  MONITOR = 'monitor', // removed but kept for backward compatibility
}

export const isAddOn = (key: string): key is AddOns => {
  return Object.values(AddOns).includes(key as AddOns);
};
